export default "__VITE_ASSET__0b4cfbaa__"